import chroma from 'chroma-js'
import {isRtl} from '@utils'

const dot = (color = 'transparent') => ({
  alignItems: 'center',
  display: 'flex',
  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: isRtl() ? 0 : 5,
    marginLeft: isRtl() ? 5 : 0,
    height: 10,
    width: 10,
    paddingRight: 10
  }
})

export const colourStyles = {
  control: (styles: any) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles: any, { data, isDisabled, isFocused, isSelected }: { data: any, isDisabled: boolean, isFocused: boolean, isSelected: boolean }) => {
    const color = chroma(data.color)
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? data.color
          : isFocused
            ? color.alpha(0.1).css()
            : undefined,
      color: isDisabled
        ? '#ccc'
        : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : data.color,
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? data.color
            : color.alpha(0.3).css()
          : undefined
      }
    }
  },
  input: (styles: any) => ({ ...styles, ...dot() }),
  placeholder: (styles: any) => ({ ...styles, ...dot('#ccc') }),
  singleValue: (styles: any, { data }: { data: any }) => ({ ...styles, ...dot(data.color) })
}

interface StyleProps {
  isColored?: boolean;
  styles?: any;
  [key: string]: any;
}

export const SelectStyleAction = (props: StyleProps) => {
  if (props.isColored) {
    return colourStyles
  } else {
    return props?.styles ?? undefined
  }
}
